/* V_PT_CART_25 | Remove Extra Upsell Screens Between Cart and Checkout
 *
 * The post-cart flow has two upsell screens between the drawer and checkout:
 *   screen 2 - "Ajouter des produits supplementaires"  (.sidecart__upsell-collections)
 *   screen 3 - "Essayez de notre infusion du moment"   (.sidecart__featured-product)
 *
 * The arms are the four cells of that 2x2, so each screen's own cost is measurable:
 *   Control - drawer -> screen 2 -> screen 3 -> checkout
 *   Var A   - drawer -> screen 3 -> checkout   (body.c-ptCart25VarA)
 *   Var B   - drawer -> checkout               (body.c-ptCart25VarB)
 *   Var C   - drawer -> screen 2 -> checkout   (body.c-ptCart25VarC)
 *
 * w-sidecart.js binds the drawer's step buttons with `this.nextStep.bind(this)` /
 * `this.closePrevActions.bind(this)` ON THE BUTTON ELEMENT itself, so a prototype patch
 * after construction would not be picked up.
 *
 * Rather than cancelling those handlers, this pre-positions side-cart's step counter in the
 * capture phase so the theme's own nextStep() / previousStep() land on the right screen by
 * themselves. Nothing is preventDefault'ed and nothing is stopped, which matters for
 * measurement: an earlier version called stopImmediatePropagation() here, and that silently
 * killed every bubble-phase listener on the button - including Intelligems' click tracking,
 * which delegates on the bubble phase. The COMMANDER click event then counted in Control and
 * recorded almost nothing in the test arms.
 *
 * Reusing the theme's transitions also means the reassurance slider, the gift-step guards and
 * the checkout redirect all keep working exactly as they do for Control - no duplicated logic.
 */
(function () {
  var VAR_A = 'c-ptCart25VarA';
  var VAR_B = 'c-ptCart25VarB';
  var VAR_C = 'c-ptCart25VarC';

  var COMMANDER = 'side-cart button[name="next-step"][data-step-index="0"]';
  var UPSELL_NEXT = 'side-cart button[name="next-step"][data-action-type="upsell_collections"]';
  var BACK = 'side-cart .sidecart__close-prev';

  /* Any index past the last step makes nextStep() fall through to its own "/checkout/"
   * redirect - the same destination Control reaches at the end of the flow. It also matches
   * no [data-step-index], so nextStep()'s gift-step lookups stay false. */
  var PAST_LAST_STEP = 9999;

  function stepIndexOf(cart, selector) {
    var el = cart.querySelector(selector + '[data-step-index]');
    return el ? parseInt(el.getAttribute('data-step-index'), 10) : null;
  }

  function featuredStep(cart) {
    return stepIndexOf(cart, '.sidecart__featured-product');
  }

  function upsellStep(cart) {
    return stepIndexOf(cart, '.sidecart__upsell-collections');
  }

  document.addEventListener(
    'click',
    function (evt) {
      var classes = document.body.classList;
      var isVarA = classes.contains(VAR_A);
      var isVarB = classes.contains(VAR_B);
      var isVarC = classes.contains(VAR_C);
      if (!isVarA && !isVarB && !isVarC) return;

      // --- Leaving the cart drawer (Var A / Var B; Var C keeps Control's first hop) ---
      var commander = evt.target.closest(COMMANDER);
      if (commander) {
        if (isVarC) return;

        var cart = commander.closest('side-cart');
        if (!cart || cart.current_step !== 0) return;

        if (isVarB) {
          cart.current_step = PAST_LAST_STEP;
          return;
        }

        // Var A: land on screen 3. No screen 3 configured -> leave the theme's flow alone.
        var target = featuredStep(cart);
        if (target === null) return;
        cart.current_step = target - 1;
        return;
      }

      // --- Leaving screen 2 (Var C only): skip screen 3 and go straight to checkout ---
      if (isVarC) {
        var upsellNext = evt.target.closest(UPSELL_NEXT);
        if (!upsellNext) return;

        var upsellCart = upsellNext.closest('side-cart');
        if (!upsellCart) return;

        var upsell = upsellStep(upsellCart);
        if (upsell === null || upsellCart.current_step !== upsell) return;
        // Nothing to skip if screen 3 is not configured - keep the theme's flow.
        if (featuredStep(upsellCart) === null) return;

        upsellCart.current_step = PAST_LAST_STEP;
        return;
      }

      // --- Var A: back from screen 3 returns to the drawer, since screen 2 was never shown ---
      if (!isVarA) return;
      var back = evt.target.closest(BACK);
      if (!back) return;

      var sideCart = back.closest('side-cart');
      if (!sideCart) return;
      var featured = featuredStep(sideCart);
      if (featured === null || sideCart.current_step !== featured) return;
      if (upsellStep(sideCart) === null) return;

      // closePrevActions() calls previousStep() for any step but 0, which decrements to 0.
      sideCart.current_step = 1;
    },
    true
  );
})();
